import Vue from 'vue';
import { store } from '@/plugins/store';
import { isProcessStateOK, newMessage } from '@/base/js/ProcessDataHelper';
import { checkUserRight } from '@/base/js/baseHelper.js';

/* *****************************************************
 * CalcTypes
***************************************************** */
export const refreshCalcTypeList = async () => {
  store.state.condAdmin.calcTypeList = [];
  store.state.condAdmin.calcTypesLoading = true;
  let ioData = {
    clientKey: store.state.condAdmin.clientKey
  };

  let processData = await Vue.prototype.$restClient.callProcess('condAdmin', 'getCalcTypeList', ioData);
  if (isProcessStateOK(processData)) {
    store.state.condAdmin.calcTypeList = processData.ioData.calcTypeList;
    // for (let elem of store.state.condAdmin.calcTypeList) {
    //   prepareCalcTypeListElement(elem);
    // }
  } else {
    Vue.prototype.$globals.Info.open(processData.processState.messages);
  }
  store.state.condAdmin.calcTypesLoading = false;
};

export const getCalcTypeDurations = (calcType) => {
  // console.log('getCalcTypeDurations', calcType, '\n', JSON.stringify(store.state.condAdmin.calcTypeList));
  let ct = store.state.condAdmin.calcTypeList.find((i) => i.calcType === calcType);
  return ct.settings.durations.sort((a, b) => { return a - b; });
};

/* *****************************************************
 * ProductType
***************************************************** */
export const refreshProductTypeList = async () => {
  store.state.condAdmin.productTypeList = [];
  store.state.condAdmin.productTypesLoading = true;
  let ioData = {
    clientKey: store.state.condAdmin.clientKey
  };

  let processData = await Vue.prototype.$restClient.callProcess('condAdmin', 'getProductTypeList', ioData);
  if (isProcessStateOK(processData)) {
    store.state.condAdmin.productTypeList = processData.ioData.productTypeList;
  } else {
    Vue.prototype.$globals.Info.open(processData.processState.messages);
  }
  store.state.condAdmin.productTypesLoading = false;
};

/* *****************************************************
 * Product
***************************************************** */
export const refreshProductList = async (clientKey = null) => {
  store.state.condAdmin.productList = null;
  store.state.condAdmin.productsLoading = true;
  /*
  let ioData = {
    clientKey: clientKey || store.state.condAdmin.clientKey
  };
  let processData = await Vue.prototype.$restClient.callProcess('condAdmin', 'getProductList', ioData);
    if (isProcessStateOK(processData)) {
      store.state.condAdmin.productList = processData.ioData.productList || [];
    } else {
      Vue.prototype.$globals.Info.open(processData.processState.messages);
    }
  */
  let ioData = {
    clientKey: clientKey || store.state.condAdmin.clientKey,
    startIndex: 0,
    maxObjects: 8000
  };
  let maxWheels = 0;
  let processData = null;
  let productList = [];
  while (ioData.startIndex > -1 && maxWheels < 100) {
    processData = await Vue.prototype.$restClient.callProcess('condAdmin', 'getProductList', ioData);
    if (isProcessStateOK(processData)) {
      productList = productList.concat(processData.ioData.productList);
      ioData.startIndex = processData.ioData.startIndex;
      maxWheels++;
    } else {
      Vue.prototype.$globals.Info.open(processData.processState.messages);
      ioData.startIndex = -1;
    }
  }
  store.state.condAdmin.productsLoading = false;
  store.state.condAdmin.productList = productList || [];
  // return processData.ioData.productList;
  return productList;
};

export const updateProductState = async (product, state) => {
  // check rights
  if (!hasUserRight('manageResidualValues', null, [product.brand])) {
    Vue.prototype.$globals.Info.open([newMessage('userError', Vue.prototype.$t('base.error.insufficientRights'))]);
    return;
  }
  let ioData = {
    clientKey: store.state.condAdmin.clientKey,
    productUid: product.uid,
    state: state
  };
  let processData = await Vue.prototype.$restClient.callProcess('condAdmin', 'updateProductState', ioData);
  if (isProcessStateOK(processData)) {
    product.state = state;
  } else {
    Vue.prototype.$globals.Info.open(processData.processState.messages);
  }
};

export const saveProduct = async (product) => {
  let ioData = {
    clientKey: store.state.condAdmin.clientKey,
    product: product
  };

  // validation
  let messages = [];
  if (product.productTypeUid == null) {
    messages.push({ type: 'userError', message: Vue.prototype.$t('base.missingMandatory') + Vue.prototype.$t('condAdmin.product.productType') });
  }
  if (messages.length > 0) {
    Vue.prototype.$globals.Info.open(messages);
    return null;
  } else {
    let processName = 'updateProduct';
    if (product.uid == null) processName = 'createProduct';
    let processData = await Vue.prototype.$restClient.callProcess('condAdmin', processName, ioData);
    if (isProcessStateOK(processData)) {
      if (processName === 'createProduct') {
        store.state.condAdmin.productList.push(processData.ioData.product);
      } else {
        let pIndex = store.state.condAdmin.productList.findIndex((p) => p.uid === processData.ioData.product.uid);
        store.state.condAdmin.productList[pIndex] = processData.ioData.product;
      }
      return processData.ioData.product;
    } else {
      Vue.prototype.$globals.Info.open(processData.processState.messages);
      return null;
    }
  }
};

export const productUniqueCheck = (product) => {
  let existing = store.state.condAdmin.productList.find((i) =>
    i.productTypeUid === product.productTypeUid &&
    i.brand === product.brand &&
    i.productName === product.productName &&
    i.productKey === product.productKey &&
    i.orderKey === product.orderKey &&
    i.chassis === product.chassis &&
    i.driveType === product.driveType &&
    i.serialId === product.serialId
  );
  if (existing != null) console.log('Existing Product:', JSON.stringify(existing));
  return existing;
};

export const copyProduct = (source = {}, isNew = false) => {
  return {
    id: source.id != null && !isNew ? source.id : null,
    productUid: source.productUid != null && !isNew ? source.productUid : null, // +cb 05.2025
    uid: source.uid != null && !isNew ? source.uid : null,
    productTypeUid: source.productTypeUid != null ? source.productTypeUid : null,
    brand: source.brand != null ? source.brand : null,
    productName: source.productName != null ? source.productName : null,
    productKey: source.productKey != null ? source.productKey : null,
    orderKey: source.orderKey != null ? source.orderKey : null,
    chassis: source.chassis != null ? source.chassis : null,
    driveType: source.driveType != null ? source.driveType : null,
    serialId: source.serialId != null ? source.serialId : null,
    state: source.state != null ? source.state : 1,
    prv: source.prv != null && !isNew ? source.prv : null,
    inherited: source.inherited != null && !isNew ? source.inherited : false
  };
};
/* *****************************************************
 * DriveType
***************************************************** */
export const refreshDriveTypeList = async (clientKey = null) => {
  store.state.condAdmin.driveTypeList = null;
  store.state.condAdmin.driveTypeLoading = true;
  let ioData = {
    clientKey: clientKey || store.state.condAdmin.clientKey
  };

  let processData = await Vue.prototype.$restClient.callProcess('condAdmin', 'getDriveTypeList', ioData);
  if (isProcessStateOK(processData)) {
    store.state.condAdmin.driveTypeList = processData.ioData.driveTypeList || [];
  } else {
    Vue.prototype.$globals.Info.open(processData.processState.messages);
  }
  store.state.condAdmin.driveTypeLoading = false;
  return processData.ioData.driveTypeList;
};

export const saveDriveType = async (driveType) => {
  let ioData = {
    clientKey: store.state.condAdmin.clientKey,
    driveType: driveType
  };

  // validation
  let messages = [];
  if (driveType.driveTypeName == null) {
    messages.push({ type: 'userError', message: Vue.prototype.$t('base.missingMandatory') + Vue.prototype.$t('condAdmin.driveType.driveTypeName') });
  }
  if (messages.length > 0) {
    Vue.prototype.$globals.Info.open(messages);
    return null;
  } else {
    let processName = 'updateDriveType';
    if (driveType.uid == null) processName = 'createDriveType';
    let processData = await Vue.prototype.$restClient.callProcess('condAdmin', processName, ioData);
    if (isProcessStateOK(processData)) {
      if (processName === 'createDriveType') {
        store.state.condAdmin.driveTypeList.push(processData.ioData.driveType);
      } else {
        let pIndex = store.state.condAdmin.driveTypeList.findIndex((p) => p.uid === processData.ioData.driveType.uid);
        store.state.condAdmin.driveTypeList[pIndex] = processData.ioData.driveType;
      }
      return processData.ioData.driveType;
    } else {
      Vue.prototype.$globals.Info.open(processData.processState.messages);
      return null;
    }
  }
};

export const driveTypeUniqueCheck = (driveType) => {
  let existing = store.state.condAdmin.driveTypeList.find((i) =>
    i.driveTypeUid === driveType.driveTypeUid &&
    i.driveTypeName === driveType.driveTypeName
  );
  if (existing != null) console.log('Existing DriveType:', JSON.stringify(existing));
  return existing;
};

export const copyDriveType = (source = {}, isNew = false) => {
  return {
    id: source.id != null && !isNew ? source.id : null,
    driveTypeUid: source.driveTypeUid != null && !isNew ? source.driveTypeUid : null,
    uid: source.uid != null && !isNew ? source.uid : null,
    driveTypeName: source.driveTypeName != null ? source.driveTypeName : null,
    inherited: source.inherited != null && !isNew ? source.inherited : false
  };
};

/* *****************************************************
 * RVModification
***************************************************** */
export const refreshRVModificationList = async (clientKey = null) => {
  if (clientKey == null) {
    store.state.condAdmin.rvModificationList = [];
  }
  store.state.condAdmin.rvModificationLoading = true;
  let ioData = {
    clientKey: clientKey || store.state.condAdmin.clientKey
  };

  let processData = await Vue.prototype.$restClient.callProcess('condAdmin', 'getRVModificationList', ioData);
  if (isProcessStateOK(processData)) {
    store.state.condAdmin.rvModificationList = processData.ioData.rvModificationList || [];
  } else {
    Vue.prototype.$globals.Info.open(processData.processState.messages);
  }
  store.state.condAdmin.rvModificationLoading = false;
  return processData.ioData.rvModificationList;
};

export const saveRVModification = async (rvModification) => {
  let ioData = {
    clientKey: store.state.condAdmin.clientKey,
    RVModification: rvModification
  };

  // validation
  let messages = [];
  if (rvModification.name == null) {
    messages.push({ type: 'userError', message: Vue.prototype.$t('base.missingMandatory') + Vue.prototype.$t('condAdmin.rvModification.name') });
  }
  if (messages.length > 0) {
    Vue.prototype.$globals.Info.open(messages);
    return null;
  } else {
    let processName = 'updateRVModification';
    if (rvModification.uid == null) processName = 'createRVModification';
    let processData = await Vue.prototype.$restClient.callProcess('condAdmin', processName, ioData);
    if (isProcessStateOK(processData)) {
      if (processName === 'createRVModification') {
        store.state.condAdmin.rvModificationList.push(processData.ioData.rvModification);
      } else {
        let pIndex = store.state.condAdmin.rvModificationList.findIndex((p) => p.uid === processData.ioData.rvModification.uid);
        store.state.condAdmin.rvModificationList[pIndex] = processData.ioData.rvModification;
      }
      return processData.ioData.rvModification;
    } else {
      Vue.prototype.$globals.Info.open(processData.processState.messages);
      return null;
    }
  }
};

export const rvModificationUniqueCheck = (rvModification) => {
  let existing = store.state.condAdmin.rvModificationList.find((i) =>
    i.driveTypeUid === rvModification.driveTypeUid &&
    i.driveTypeName === rvModification.name
  );
  if (existing != null) console.log('Existing RVModification:', JSON.stringify(existing));
  return existing;
};

export const copyRVModification = (source = {}, isNew = false) => {
  return {
    id: source.id != null && !isNew ? source.id : null,
    driveTypeUid: source.driveTypeUid != null && !isNew ? source.rvModificationUid : null,
    uid: source.uid != null && !isNew ? source.uid : null,
    rvModificationName: source.name != null ? source.name : null,
    inherited: source.inherited != null && !isNew ? source.inherited : false
  };
};
export const updateRVModificationState = async (rvModification, state) => {
  // check rights
  if (!hasUserRight('manageResidualValues')) {
    Vue.prototype.$globals.Info.open([newMessage('userError', Vue.prototype.$t('base.error.insufficientRights'))]);
    return;
  }
  let ioData = {
    clientKey: store.state.condAdmin.clientKey,
    rvModificationUid: rvModification.uid,
    state: state
  };
  let processData = await Vue.prototype.$restClient.callProcess('condAdmin', 'updateRVModificationState', ioData);
  if (isProcessStateOK(processData)) {
    rvModification.state = state;
  } else {
    Vue.prototype.$globals.Info.open(processData.processState.messages);
  }
};

/* *****************************************************
 * ResidualValues
***************************************************** */
export const minRVValues = {
  de: 10.0,
  ch: 5.0
};

/* *****************************************************
 * common
***************************************************** */
export const formatLock = (lock) => {
  lock.timestamp = Vue.prototype.$filters.formatDateTime(lock.timestamp);
  return lock;
};

export const removeLock = async (type, uid, version = null) => {
  let ioData = {
    clientKey: store.state.condAdmin.clientKey,
    targetType: type,
    targetIdentifier: uid
  };
  if (version != null) ioData.targetVersion = version;

  let processData = await Vue.prototype.$restClient.callProcess('condAdmin', 'removeLock', ioData, true);
  Vue.prototype.$globals.Info.open(processData.processState.messages);
};

export const hasUserRight = (askedRight, providerUid = null, brandList = null) => {
  // check detailed userRight based on provider and brands
  let askedRestrictions = [];
  if (providerUid != null) {
    askedRestrictions.push({ key: 'provider', value: providerUid });
  }
  if (brandList != null) {
    askedRestrictions.push({ key: 'brand', value: brandList, linkType: 'AND' });
  }
  return checkUserRight(store.state.condAdmin.userRights, askedRight, askedRestrictions);
};
